import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogTitle, DialogContent, Box, Typography, FormControl, Select, MenuItem, TextField, Button } from '@mui/material';

const planetOptions = [
  'Sun', 'Moon', 'Mercury', 'Venus', 'Mars', 'Jupiter',
  'Uranus', 'Neptune', 'Pluto', 'Rahu', 'Ketu'
];

const StrategyReportStudyBDialog = ({ open, onClose }) => {
  // Block 4 state
  const [block4Planet1, setBlock4Planet1] = useState(planetOptions[0]);
  const [block4Planet2, setBlock4Planet2] = useState(planetOptions[1]);
  const [block4Event, setBlock4Event] = useState('Retro');
  // Block 1: Buy X days before planet enters sign, sell Y days after
  const [block1, setBlock1] = useState({
    buyPlanet: planetOptions[0],
    buyDaysBefore: '',
    buySign: '',
    sellPlanet: planetOptions[1],
    sellDaysAfter: '',
    sellSign: '',
  });

  // Block 2: Buy when planet is X, sell when planet is Y
  const [block2, setBlock2] = useState({
    buyPlanet: planetOptions[1],
    buyIs: '',
    sellPlanet: planetOptions[2],
    sellIs: '',
  });

  // Block 3: Planet conjunct Star (BUY/SELL)
  const [block3Rows, setBlock3Rows] = useState([
    { planet: planetOptions[1], star: 'Star 1', type: 'BUY' },
    { planet: planetOptions[1], star: 'Star 1', type: 'SELL' },
  ]);

  const starOptions = ['Star 1', 'Star 2', 'Star 3'];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth PaperProps={{ sx: { minWidth: 1200, maxWidth: 1200, minHeight: 520, borderRadius: 2, m: 0 } }}>
      <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold', fontSize: 26, pb: 0 }}>Strategy Report Study B</DialogTitle>
      <DialogContent sx={{ p: 2, pt: 1, pb: 0, mb: 0, background: '#fafafa' }}>
        {/* Block 1 */}
        <Box sx={{ border: '1px solid #ccc', borderRadius: 2, mb: 2, p: 1.5, display: 'flex', alignItems: 'center', minWidth: 1100 }}>
          <Typography sx={{ fontWeight: 'bold', textTransform: 'uppercase' }}>BUY</Typography>
          <TextField size="small" sx={{ width: 60, mx: 1 }} type="number" value={block1.buyDaysBefore} onChange={e => setBlock1({ ...block1, buyDaysBefore: e.target.value })} />
          <Typography>Days before Planet</Typography>
          <FormControl size="small" sx={{ minWidth: 90, mx: 1 }}>
            <Select value={block1.buyPlanet} onChange={e => setBlock1({ ...block1, buyPlanet: e.target.value })}>
              {planetOptions.map(p => <MenuItem key={p} value={p}>{p}</MenuItem>)}
            </Select>
          </FormControl>
          <Typography>enters sign</Typography>
          <FormControl size="small" sx={{ minWidth: 90, mx: 1 }}>
  <Select value={block1.buySign} onChange={e => setBlock1({ ...block1, buySign: e.target.value })}>
    {['Aries','Taurus','Gemini','Cancer','Leo','Virgo','Libra','Scorpio','Sagittarius','Capricorn','Aquarius','Pisces'].map(sign => (
      <MenuItem key={sign} value={sign}>{sign}</MenuItem>
    ))}
  </Select>
</FormControl>
          <Typography sx={{ fontWeight: 'bold', textTransform: 'uppercase', mx: 2 }}>AND SELL</Typography>
          <TextField size="small" sx={{ width: 60, mx: 1 }} type="number" value={block1.sellDaysAfter} onChange={e => setBlock1({ ...block1, sellDaysAfter: e.target.value })} />
          <Typography>Days after</Typography>
          <FormControl size="small" sx={{ minWidth: 90, mx: 1 }}>
            <Select value={block1.sellPlanet} onChange={e => setBlock1({ ...block1, sellPlanet: e.target.value })}>
              {planetOptions.map(p => <MenuItem key={p} value={p}>{p}</MenuItem>)}
            </Select>
          </FormControl>
          <Typography>enters sign</Typography>
          <FormControl size="small" sx={{ minWidth: 90, mx: 1 }}>
  <Select value={block1.sellSign} onChange={e => setBlock1({ ...block1, sellSign: e.target.value })}>
    {['Aries','Taurus','Gemini','Cancer','Leo','Virgo','Libra','Scorpio','Sagittarius','Capricorn','Aquarius','Pisces'].map(sign => (
      <MenuItem key={sign} value={sign}>{sign}</MenuItem>
    ))}
  </Select>
</FormControl>
          <Button variant="contained" sx={{ width: 100, height: 40, ml: 2 }} disabled>RUN</Button>
        </Box>

        {/* Block 2 */}
        <Box sx={{ border: '1px solid #ccc', borderRadius: 2, mb: 2, p: 1.5, display: 'flex', alignItems: 'center', minWidth: 1100 }}>
          <Typography sx={{ fontWeight: 'bold', textTransform: 'uppercase', mr: 1 }}>BUY</Typography><Typography sx={{ mx: 2, flexGrow: 0.5 }}>when Planet</Typography>
          <FormControl size="small" sx={{ minWidth: 90, mx: 1 }}>
            <Select value={block2.buyPlanet} onChange={e => setBlock2({ ...block2, buyPlanet: e.target.value })}>
              {planetOptions.map(p => <MenuItem key={p} value={p}>{p}</MenuItem>)}
            </Select>
          </FormControl>
          <Typography>Is</Typography>
          <FormControl size="small" sx={{ minWidth: 90, mx: 1 }}>
            <Select value={block2.buyIs} onChange={e => setBlock2({ ...block2, buyIs: e.target.value })}>
              {[
                'Retro','Direct','Conbust','Peak N Decl','Peak S Decl','Zero Decl','Apogee','Perigee','Accelerating','Slowing Down'
              ].map(option => (
                <MenuItem key={option} value={option}>{option}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <Typography sx={{ fontWeight: 'bold', textTransform: 'uppercase', mr: 1 }}>AND SELL</Typography><Typography sx={{ mx: 2, flexGrow: 0.5 }}>when Planet</Typography>
          <FormControl size="small" sx={{ minWidth: 90, mx: 1 }}>
            <Select value={block2.sellPlanet} onChange={e => setBlock2({ ...block2, sellPlanet: e.target.value })}>
              {planetOptions.map(p => <MenuItem key={p} value={p}>{p}</MenuItem>)}
            </Select>
          </FormControl>
          <Typography>Is</Typography>
          <FormControl size="small" sx={{ minWidth: 90, mx: 1 }}>
            <Select value={block2.sellIs} onChange={e => setBlock2({ ...block2, sellIs: e.target.value })}>
              {[
                'Retro','Direct','Conbust','Peak N Decl','Peak S Decl','Zero Decl','Apogee','Perigee','Accelerating','Slowing Down'
              ].map(option => (
                <MenuItem key={option} value={option}>{option}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <Button variant="contained" sx={{ width: 100, height: 40, ml: 2 }} disabled>RUN</Button>
        </Box>

        {/* Block 3 */}
        <Box sx={{ border: '1px solid #ccc', borderRadius: 2, mb: 2, p: 1.5, display: 'flex', alignItems: 'center', minWidth: 1100, gap: 2 }}>
  <Typography sx={{ fontWeight: 'bold', minWidth: 60, textTransform: 'uppercase', mr: 1 }}>BUY</Typography>
  <Typography sx={{ mr: 1 }}>when Planet</Typography>
  <FormControl size="small" sx={{ minWidth: 90, mr: 1 }}>
    <Select value={block3Rows[0].planet} onChange={e => {
      const arr = [...block3Rows]; arr[0].planet = e.target.value; setBlock3Rows(arr);
    }}>{planetOptions.map(p => <MenuItem key={p} value={p}>{p}</MenuItem>)}</Select>
  </FormControl>
  <Typography sx={{ mr: 1 }}>Conjunct</Typography>
  <FormControl size="small" sx={{ minWidth: 90, mr: 3 }}>
    <Select value={block3Rows[0].star} onChange={e => {
      const arr = [...block3Rows]; arr[0].star = e.target.value; setBlock3Rows(arr);
    }}>{starOptions.map(s => <MenuItem key={s} value={s}>{s}</MenuItem>)}</Select>
  </FormControl>
  <Typography sx={{ mr: 1 }}>And</Typography>
  <Typography sx={{ fontWeight: 'bold', minWidth: 60, textTransform: 'uppercase', mr: 1 }}>SELL</Typography>
  <Typography sx={{ mr: 1 }}>when Planet</Typography>
  <FormControl size="small" sx={{ minWidth: 90, mr: 1 }}>
    <Select value={block3Rows[1].planet} onChange={e => {
      const arr = [...block3Rows]; arr[1].planet = e.target.value; setBlock3Rows(arr);
    }}>{planetOptions.map(p => <MenuItem key={p} value={p}>{p}</MenuItem>)}</Select>
  </FormControl>
  <Typography sx={{ mr: 1 }}>Conjunct</Typography>
  <FormControl size="small" sx={{ minWidth: 90, mr: 3 }}>
    <Select value={block3Rows[1].star} onChange={e => {
      const arr = [...block3Rows]; arr[1].star = e.target.value; setBlock3Rows(arr);
    }}>{starOptions.map(s => <MenuItem key={s} value={s}>{s}</MenuItem>)}</Select>
  </FormControl>
  <Button variant="contained" sx={{ width: 140, height: 44, alignSelf: 'flex-end', ml: 'auto' }} disabled>RUN</Button>
</Box>

        {/* Block 4 */}
        <Box sx={{ border: '1px solid #ccc', borderRadius: 2, mb: 2, p: 1.5, display: 'flex', alignItems: 'center', minWidth: 1100 }}>
          <Typography>Planet</Typography>
          <FormControl size="small" sx={{ minWidth: 90, mx: 1 }}>
            <Select value={block4Planet1} onChange={e => setBlock4Planet1(e.target.value)}>
              {planetOptions.map(p => <MenuItem key={p} value={p}>{p}</MenuItem>)}
            </Select>
          </FormControl>
          <Typography>Is</Typography>
          <FormControl size="small" sx={{ minWidth: 120, mx: 1 }}>
            <Select value={block4Event} onChange={e => setBlock4Event(e.target.value)}>
              {['Retro','Direct','Conbust','Peak N Decl','Peak S Decl','Zero Decl','Apogee','Perigee','Accelerating','Slowing Down'].map(option => (
                <MenuItem key={option} value={option}>{option}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <Typography sx={{ mx: 2 }}>And Planet</Typography>
          <FormControl size="small" sx={{ minWidth: 90, mx: 1 }}>
            <Select value={block4Planet2} onChange={e => setBlock4Planet2(e.target.value)}>
              {planetOptions.map(p => <MenuItem key={p} value={p}>{p}</MenuItem>)}
            </Select>
          </FormControl>
          <Button variant="contained" sx={{ width: 100, height: 40, ml: 2 }} disabled>RUN</Button>
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2, mb: 3, pb: 0 }}>
          <Button variant="outlined" color="secondary" onClick={onClose} sx={{ minWidth: 100, height: 40 }}>
            CLOSE
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

StrategyReportStudyBDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default StrategyReportStudyBDialog;
